module.exports = __webpack_public_path__ + "static/media/twitter-white.b060ee2e.svg";